
import Vue from "vue";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { BrowserClient } from "@sentry/browser";

const config = {
  dsn: process.env.MIX_SENTRY_DSN,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  environment: process.env.NODE_ENV
};

const client = new BrowserClient(config);

// Only init in prod
if (process.env.NODE_ENV == "production") {
  Sentry.init(config);
}

export default client;
